import PopupMessage, { PopupMessageRedux, PopupMessageContext } from "./styles";
import { throwPopupMessage, closePopup } from "./model";

export default PopupMessage;
export { PopupMessageRedux, throwPopupMessage, closePopup, PopupMessageContext };
